import { Box, makeStyles, Typography } from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";
import React from "react";

const useStyles = makeStyles({
  tabSubTitle: {
    background: "#aaa",
    textTransform: "capitalize"
  },
  cursorPointer: {
    cursor: "pointer"
  },
  helpIcon: {
    marginLeft: 8,
    cursor: "pointer"
  }
});

const CustomCardHeader = ({ label, extraContent, onHelp }) => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      p={1}
      mb={2}
      className={classes.tabSubTitle}
    >
      <Box display="flex">
        <Typography>
          <strong>{label}</strong>
        </Typography>
        {onHelp && (
          <HelpOutline className={classes.helpIcon} onClick={onHelp} />
        )}
      </Box>
      {extraContent}
    </Box>
  );
};

export default CustomCardHeader;
